<template>
	<div class="card-body files">
		<h3>{{ $t('courses.file_attach')}}</h3>

		<div v-for="file in files" :key="file.id" class="file">
			<a :href="file.url" @click="pageResourceClicked(file.item_id,file.id)" target="_blank"><i :class="'fa fa-3x m-1 mr-3 ' + font_awesome_file_icon_class(file.mime_type)" />
			<span>{{file.filename}}</span></a>
			<div class="clearfix"></div>
		</div>

	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapMimeTypeFontAwesomeActions } from '@/lib/mimetype_fontawesome';

export default {
	name: 'Resources',
	props: {
		files: {
			type: Object
		},
		task_id: {
			type: String
		},
		stage_id: {
			type: String
		}

	},
	computed: {
		enrol_id () {
			return this.$route.params.enrol_id;
		}
	},
	methods: {
		...mapActions(['pageResourceView']),
		...mapMimeTypeFontAwesomeActions,
		pageResourceClicked(page_id,resource_id){
		  this.pageResourceView({enrol_id:this.enrol_id,stage_id: this.stage_id, task_id:this.task_id,page_id,resource_id});
		}
	}
}
</script>

<style>
.files .file {
	padding: 0.8em;
}
.files .file:nth-child(odd) { /*  Zebra */
	background: #EEE;
}
.files .file .fa {
	float: left;
}
.files .file span {
	margin-top: 1.0em;
	display: inline-block;
}

@media (max-width: 576px) {
	.files .file {
		text-align: center;
	}
	.files .file .fa {
		float: none;
	}
	.files .file span {
		margin-top: auto;
	}
}

@mixin clearfix() {
	&::after {
		display: block;
		content: "";
		clear: both;
	}
}
.element {
	@include clearfix;
}
</style>
